// 提供浏览器文件下载功能
/**
 * 提供基础的图片下载功能
 * @param base64 base64 String
 * @param fileName 文件名称 如 *.png
 */
export const downloadImage = function (base64, fileName = 'default.png') {
  if (!base64) { return }
  const downloadEle = document.createElement('a')
  downloadEle.href = base64
  downloadEle.download = fileName
  document.body.appendChild(downloadEle)
  downloadEle.click()
  document.body.removeChild(downloadEle)
}
